import { baseApi } from './baseApi';

function trackingListArg(arg) {
  if (arg && typeof arg === 'object' && !Array.isArray(arg)) return arg;
  if (arg == null || arg === '') return {};
  return { accountId: arg };
}

export const behaviourApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Master non-compliance parameters for the form. */
    getBehaviourMasterData: builder.query({
      query: () => '/api/account_behaviour_trackings/behaviour_data',
      providesTags: ['BehaviourTrackings'],
    }),
    getBehaviourEmployees: builder.query({
      query: () => '/api/accounts/behaviour_employees',
      providesTags: ['BehaviourTrackings'],
    }),
    /** Existing behaviour tracking rows. */
    getAccountBehaviourTrackings: builder.query({
      query: (arg) => {
        const { accountId, page, per_page, search, start_date, end_date } =
          trackingListArg(arg);
        const params = {};
        if (accountId != null && accountId !== '') params.account_id = accountId;
        if (page) params.page = page;
        if (per_page) params.per_page = per_page;
        if (search) params.search = search;
        if (start_date) params.start_date = start_date;
        if (end_date) params.end_date = end_date;
        return {
          url: '/api/account_behaviour_trackings',
          params,
        };
      },
      providesTags: (_r, _e, arg) => {
        const { accountId } = trackingListArg(arg);
        if (accountId != null && accountId !== '') {
          return [{ type: 'BehaviourTrackings', id: String(accountId) }];
        }
        return ['BehaviourTrackings'];
      },
    }),
    createAccountBehaviourTracking: builder.mutation({
      query: (body) => ({
        url: '/api/account_behaviour_trackings',
        method: 'POST',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [
        'BehaviourTrackings',
        { type: 'BehaviourTrackings', id: String(arg?.account_id) },
      ],
    }),
    getAccountBehaviourTrackingById: builder.query({
      // Backend show-by-id currently returns 422; kept for compatibility if fixed later.
      query: (id) => `/api/account_behaviour_trackings/${encodeURIComponent(String(id ?? ''))}`,
      providesTags: (_r, _e, id) => [{ type: 'BehaviourTrackings', id: String(id) }],
    }),
    updateAccountBehaviourTracking: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/api/account_behaviour_trackings/${encodeURIComponent(String(id ?? ''))}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: (_r, _e, arg) => [
        'BehaviourTrackings',
        { type: 'BehaviourTrackings', id: String(arg?.id) },
        { type: 'BehaviourTrackings', id: String(arg?.account_id) },
      ],
    }),
  }),
});

export const {
  useGetBehaviourMasterDataQuery,
  useGetBehaviourEmployeesQuery,
  useGetAccountBehaviourTrackingsQuery,
  useGetAccountBehaviourTrackingByIdQuery,
  useCreateAccountBehaviourTrackingMutation,
  useUpdateAccountBehaviourTrackingMutation,
} = behaviourApi;
